<div class="form-row row">
  <div class="form-group col-3">
    <div class="form-row row">
      <div class="form-group align-items-center">
        <span class="text">{{'i18n.domain.import-configuration.edit.file.column-based.available-sources' |
          translate}}</span>
      </div>
    </div>
    <div class="form-row row">
      <div class="form-group">

        <ejs-grid #grid rowHeight="38" class="grid-with-toolbar source-grid"
          [dataSource]="configurationFormFile.controls.possibleSources.value"
          [editSettings]="editSettings"
          (actionBegin)="sourceGridActionBegin($event)"
          (actionComplete)="sourceGridActionComplete($event)">
          <ng-template #toolbarTemplate let-data>
            <ejs-toolbar>
              <e-items>
                <e-item
                  [text]="'i18n.domain.import-configuration.edit.file.column-based.upload-file-tooltip' | translate"
                  prefixIcon='e-icons icon-cloud--upload' (click)="openUploader()"></e-item>
                <e-item [title]="'i18n.domain.import-configuration.edit.file.column-based.add-source' | translate"
                  prefixIcon='e-icons icon-add' (click)="this.grid.addRecord()"></e-item>
              </e-items>
            </ejs-toolbar>
          </ng-template>
          <e-columns>
            <e-column field="idToShutUpSyncfusion" [isPrimaryKey]="true" [visible]="false"></e-column>
            <e-column field="sourceElementName"
              headerText="{{'i18n.domain.import-configuration.edit.file.column-based.column-name' | translate}}"
              clipMode="Ellipsis">
              <ng-template #template let-data>
                <div class="d-flex">
                  <div class="pt-1">
                    {{getColumnDisplayName(data)}}
                  </div>
                  <ejs-tooltip id='ic-tooltip' content="{{ data.sourceElementSelectionPath }}">
                    <span class="icon-information px-1"></span>
                  </ejs-tooltip>
                </div>
              </ng-template>
            </e-column>
            <e-column headerText="" [commands]='sourceFieldGridCommands' width='40px'></e-column>
          </e-columns>
          <ng-template #editSettingsTemplate let-data>
            <app-source-edit-form [sourceEditForm]="sourceEditForm">
            </app-source-edit-form>
          </ng-template>
        </ejs-grid>
      </div>
    </div>
  </div>
  <div class="form-group col-9">
    <app-field-assignment-grid #fieldAssignmentGrid [isColumnBased]="true"></app-field-assignment-grid>
  </div>
</div>

<ejs-dialog #dialog [isModal]="true" [showCloseIcon]="true" [visible]="false">
  <ng-template #header>
    {{'i18n.domain.import-configuration.edit.file.column-based.upload-file' | translate}} ({{allowedExtensions}})
  </ng-template>
  <ng-template #content>
    <div #dropArea id='ic-dropArea'>
      <ejs-uploader #defaultupload id="ic-certificateMedia" [allowedExtensions]="allowedExtensions" multiple="false"
        [dropArea]="dropArea" [autoUpload]="false" (removing)="onFileRemove()" (selected)="handleFileInput($event)">
      </ejs-uploader>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <ng-container>
      <button class="btn btn-secondary mr-2" (click)="closeUploader()">{{'i18n.shared.close' | translate}}</button>
    </ng-container>
  </ng-template>
</ejs-dialog>
